module.exports = __webpack_public_path__ + "static/bg-header-grade-calculators-70d78fdbf547584c3477fb8e73f54e9a.svg";